import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=2aee9b88&scoped=true"
import script from "./EmptyPage.vue?vue&type=script&lang=ts"
export * from "./EmptyPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee9b88",
  null
  
)

export default component.exports